import {styled} from "@mui/material/styles";
import {Alert} from "@mui/material";

export const AlertGeneric = styled(Alert)(({theme}) => ({
    border: "0.063rem solid",
    borderRadius: "0.75rem",
    fontWeight: theme.typography.fontWeightRegular
}));
